import React from "react";
import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  CalendarCheck,
  CalendarDays,
  Users,
  MessageSquare,
  Inbox,
  Settings,
  FileText,
  LogOut,
  Wrench,
} from "lucide-react";
import { useAdminAuth } from "./AuthContext";
import { Toaster } from "../components/ui/toaster";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarCheck },
  { to: "/admin/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/conversations", label: "Conversations", icon: Inbox },
  { to: "/admin/messages", label: "Quote Enquiries", icon: MessageSquare },
  { to: "/admin/communications", label: "Communications", icon: Settings },
  { to: "/admin/templates", label: "Templates", icon: FileText },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 bg-[#07304f] text-white flex flex-col">
        <div className="px-5 py-5 flex items-center gap-3 border-b border-white/10">
          <div className="w-10 h-10 rounded-lg bg-[#0a4f8a] flex items-center justify-center">
            <Wrench size={20} className="text-sky-300" />
          </div>
          <div>
            <div className="font-extrabold text-sm">Cheerings</div>
            <div className="text-xs text-sky-300 uppercase tracking-wider">Admin</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {LINKS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-sky-500 text-white" : "text-white/75 hover:bg-white/10"
                }`
              }
            >
              <Icon size={17} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10">
          <div className="px-3 py-2 mb-2 text-xs text-white/60">
            Signed in as <span className="text-white font-semibold">{user.username}</span>
          </div>
          <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-white/75 hover:bg-white/10">
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
      <Toaster />
    </div>
  );
}
